import { createContext, useContext } from 'react';

// Default to true so isolated gate tests/components rendered without FeatureFlagProvider
// preserve the previous behavior unless app-level orchestration opts in.
export const TenantFlagResolutionReadyContext = createContext<boolean>(true);

export function useTenantFlagResolutionReady(): boolean {
  return useContext(TenantFlagResolutionReadyContext);
}
